import { QarepaEnumInformation } from '@qarepa/common';

export enum CheckRequestTypeEnum {
  STORE = 'STORE',
  UPDATE = 'UPDATE',
  DESTROY = 'DESTROY',
}

export const CheckRequestTypeArray: CheckRequestTypeEnum[] = [
  CheckRequestTypeEnum.STORE,
  CheckRequestTypeEnum.UPDATE,
  CheckRequestTypeEnum.DESTROY,
];

export const CheckRequestTypeInfo: QarepaEnumInformation<CheckRequestTypeEnum> =
  {
    [CheckRequestTypeEnum.STORE]: {
      name: $localize`Creación`,
    },
    [CheckRequestTypeEnum.UPDATE]: {
      name: $localize`Actualización`,
    },
    [CheckRequestTypeEnum.DESTROY]: {
      name: $localize`Eliminación`,
    },
  };
